import React from 'react';
import styled from 'styled-components';
import { GridSection, Eyebrow, SectionTitle } from './GridSection';

const Row = styled.div`
  display: grid;
  grid-template-columns: 200px 1fr;
  gap: 20px;
  padding: 16px 0;
  border-top: 1px solid var(--rule);

  &:last-child { border-bottom: 1px solid var(--rule); }

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
    gap: 4px;
  }
`;

const Domain = styled.div`
  font-style: italic;
  font-size: 1.05rem;
  color: var(--ink);
  overflow-wrap: anywhere;
`;

const Items = styled.div`
  font-size: 1rem;
  color: var(--ink-soft);
  line-height: 1.7;
  overflow-wrap: anywhere;
`;

const groups = [
  { name: 'Backend & APIs', items: 'Python, TypeScript, Go, Java, Node.js, Django, FastAPI, REST, gRPC, GraphQL, PostgreSQL, Redis, Kafka' },
  { name: 'Machine learning', items: 'PyTorch, TensorFlow, Transformers, JEPA, self-supervised learning, CNNs, scikit-learn' },
  { name: 'Autonomous vehicles', items: 'NAVSIM, OpenScene, nuPlan, vision-based planning, BEV perception' },
  { name: 'MLOps & serving', items: 'model versioning, inference APIs, drift monitoring, Vertex AI, SageMaker' },
  { name: 'Cloud & infra', items: 'GCP, AWS, Kubernetes, Docker, Terraform, GitHub Actions, Prometheus, Grafana' },
  { name: 'Embedded & HPC', items: 'C, STM32, FreeRTOS, DSP, SLURM, MPI, distributed training' }
];

function Skills() {
  return (
    <GridSection id="expertise">
      <Eyebrow>ii — toolkit</Eyebrow>
      <SectionTitle>What I work with.</SectionTitle>
      {groups.map(g => (
        <Row key={g.name}>
          <Domain>{g.name}</Domain>
          <Items>{g.items}</Items>
        </Row>
      ))}
    </GridSection>
  );
}

export default Skills;
